//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/Routing.js";
import "../Preferences/Preferences.RoutingApplicationView.js";
let d=[[],[[["num_allowed_curves"],"GetAllowedCurves",{R_:{allowed_curves:""}},0,0],[["allowed_curves"],"SetAllowedCurves",{},1,0],[["num_allowed_corners"],"GetAllowedCorners",{R_:{allowed_corners:""}},0,0],[["allowed_corners"],"SetAllowedCorners",{},1,0],[[],"GetDefaultCorner",{R_:{default_corner:''}},0,0],[["default_corner"],"SetDefaultCorner",{},1,0],[[],"GetBendRadiusMethod",{R_:{radius_method:''}},0,0],[["radius_method"],"SetBendRadiusMethod",{},1,0],[[],"GetBendRadius",{R_:{bend_radius:''}},0,0],[["bend_radius"],"SetBendRadius",{},1,0],[[],"GetBendRadiusUnits",{R_:{radius_units:''}},0,0],[["radius_units"],"SetBendRadiusUnits",{},1,0],[[],"GetBendRatio",{R_:{bend_ratio:''}},0,0],[["bend_ratio"],"SetBendRatio",{},1,0],[[],"GetBendRatioToAttribute",{R_:{bend_ratio_to_attribute:''}},0,0],[["bend_ratio_to_attribute"],"SetBendRatioToAttribute",{},1,0],[[],"GetBendAttributeName",{R_:{bend_attribute_name:''}},0,0],[["bend_attribute_name"],"SetBendAttributeName",{},1,0],[[],"GetBendRadiusTable",{R_:{bend_table_spreadsheet:''}},0,0],[["bend_table_spreadsheet"],"SetBendRadiusTable",{},1,0],[["stock_part_number","num_stock_rows"],"GetBendRadiusTableDataForStock",{R_:{stock_rows:"Routing.CharacteristicList[]"}},1,0],[[],"GetCreateSmartRcps",{R_:{create_smart:''}},0,0],[["create_smart"],"SetCreateSmartRcps",{},1,0],[[],"GetMergeDuplicateRcps",{R_:{merge_duplicates:''}},0,0],[["merge_duplicates"],"SetMergeDuplicateRcps",{},1,0],[[],"GetConfirmBranchSelection",{R_:{confirm_branch_sel:''}},0,0],[["confirm_branch_sel"],"SetConfirmBranchSelection",{},1,0],[[],"GetStockOffsetExpression",{R_:{stock_offset_exp:''}},0,0],[["stock_offset_exp"],"SetStockOffsetExpression",{},1,0],[[],"GetContinueUpdateOnError",{R_:{update:''}},0,0],[["update"],"SetContinueUpdateOnError",{},1,0],[[],"GetCreateSlopeConstraints",{R_:{create_slope_constraints:''}},0,0],[["create_slope_constraints"],"SetCreateSlopeConstraints",{},1,0],[[],"GetDisplayRcps",{R_:{display_rcps:''}},0,0],[["display_rcps"],"SetDisplayRcps",{},1,0],[[],"GetDisplayPorts",{R_:{display_ports:''}},0,0],[["display_ports"],"SetDisplayPorts",{},1,0],[[],"GetDisplaySegmentConstraints",{R_:{display_constraints:''}},0,0],[["display_constraints"],"SetDisplaySegmentConstraints",{},1,0],[[],"GetDisplayAnchors",{R_:{display_anchors:''}},0,0],[["display_anchors"],"SetDisplayAnchors",{},1,0],[[],"GetDisplayPortLength",{R_:{display_port_length:''}},0,0],[["display_port_length"],"SetDisplayPortLength",{},1,0],[[],"GetHealPathCurveType",{R_:{heal_path_curve_type:''}},0,0],[["heal_path_curve_type"],"SetHealPathCurveType",{},1,0],[[],"GetCreateSplineTangency",{R_:{apply_tangency:''}},0,0],[["apply_tangency"],"SetCreateSplineTangency",{},1,0],[[],"GetCreateNewPointsOnSubdivide",{R_:{add_points:''}},0,0],[["add_points"],"SetCreateNewPointsOnSubdivide",{},1,0],[[],"GetDisplayConnectedPorts",{R_:{display_connected_ports:''}},0,0],[["display_connected_ports"],"SetDisplayConnectedPorts",{},1,0]],[]];
SPLM.Preferences.RoutingPath = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.RoutingPath";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.RoutingPath.CurveType = Object.freeze({
    "Line" : "Line", "Arc" : "Arc", "Spline" : "Spline"});

SPLM.Preferences.RoutingPath.AllowedCornerType = Object.freeze({
    "None" : "None", "Bend" : "Bend", "Cope" : "Cope", "Miter" : "Miter", "Sbend" : "Sbend"});

SPLM.Preferences.RoutingPath.DefaultCornerType = Object.freeze({
    "None" : "None", "Bend" : "Bend", "Miter" : "Miter", "BendTable" : "BendTable"});

SPLM.Preferences.RoutingPath.RadiusMethod = Object.freeze({
    "Radius" : "Radius", "Ratio" : "Ratio", "Table" : "Table", "InnerRadius" : "InnerRadius", "RatioToAttribute" : "RatioToAttribute"});

SPLM.Preferences.RoutingPath.RadiusUnits = Object.freeze({
    "None" : "None", "Inches" : "Inches", "Millimeters" : "Millimeters"});

SPLM.Preferences.RoutingPath.CreateSmartRcps = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.Preferences.RoutingPath.MergeDupRcps = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.Preferences.RoutingPath.CreateTangency = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.Preferences.RoutingPath.AddPointsToSpline = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.Preferences.RoutingPath.ConfirmBranchSel = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.Preferences.RoutingPath.ContinueUpdOnError = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.Preferences.RoutingPath.DisplayObject = Object.freeze({
    "False" : "False", "True" : "True"});

SPLM.Preferences.RoutingPath.CreateSlopeConstraints = Object.freeze({
    "False" : "False", "True" : "True"});

export default SPLM;